import { useCallback } from "react";
import { User, CreditCard } from "lucide-react";
import UniversalSettingsDialog, { SettingsSection } from "@/components/common-components/universal-settings-dialog/UniversalSettingsDialog";
import AccountSettings from "./components/AccountSettings";
import PlansAndBillingSettings from "./components/PlansAndBillingSettings";

interface UserSettingsDialogProps {
    isOpen: boolean;
    onClose: () => void;
    initialCategory?: string;
}

type UserSettingsCategoryId = 'account' | 'plans-billing';

const UserSettingsDialog = ({ isOpen, onClose, initialCategory }: UserSettingsDialogProps) => {
    const sections: SettingsSection[] = [
        {
            id: 'user-section',
            title: 'User',
            categories: [
                {
                    id: 'account',
                    title: 'Account',
                    icon: <User className="w-5 h-5" />,
                    description: 'Manage your account settings and preferences'
                },
                {
                    id: 'plans-billing',
                    title: 'Plans & Billing',
                    icon: <CreditCard className="w-5 h-5" />,
                    description: 'Manage your subscription and billing information'
                }
            ]
        }
    ];

    const renderSettingsContent = useCallback((categoryId: string) => {
        const category = categoryId as UserSettingsCategoryId;
        
        switch (category) {
            case 'account':
                return <AccountSettings />;
            case 'plans-billing':
                return <PlansAndBillingSettings />;
            default:
                return (
                    <div className="settings-content">
                        <h3>Settings</h3>
                        <p className="text-[var(--muted-foreground)]">Select a category to configure settings</p>
                    </div>
                );
        }
    }, []);

    return (
        <UniversalSettingsDialog
            isOpen={isOpen}
            onClose={onClose}
            initialCategory={initialCategory}
            sections={sections}
            title="User Settings"
            icon={<User className="w-5 h-5" />}
            renderContent={renderSettingsContent}
            defaultCategory="account"
        />
    );
};

export default UserSettingsDialog;

